import { useCallback } from 'react';
import { selectUser } from '../../common/store/slices/auth.slice';
import { useResize } from '../../common/hooks/resize';
import { useAppSelector } from '../../common/hooks/redux';
import { INTERCOM_SECRET_KEY } from '../../common/constants';
import { useModuleProjectContext } from 'common/contexts/useModuleProjectContext';
import { SignJWT } from 'jose';
import Intercom from '@intercom/messenger-js-sdk';

export const useIntercom = () => {
  const user = useAppSelector(selectUser);
  const { activeProject } = useModuleProjectContext();
  const { isMobile } = useResize();

  const initiateIntercom = useCallback(async () => {
    if (user?.email && user.externalName && user.companyName && !isMobile && user.id) {
      const payload = {
        user_id: user.id, // Required
        email: user.email, // Optional
      };
      const key = new TextEncoder().encode(INTERCOM_SECRET_KEY);
      const token = await new SignJWT(payload)
        .setProtectedHeader({ alg: 'HS256' })
        .setIssuedAt()
        .setExpirationTime('1h')
        .sign(key);
      const config = {
        api_base: 'https://api-iam.intercom.io',
        app_id: 'y588ttna',
        company: {
          company_id: 'unknown', // Followup ticket to expose this in user data
          name: user.companyName,
        },
        custom_launcher_selector: '#intercom_help_center',
        created_at: Date.now(),
        currentProjectId: activeProject?.moduleProjectID ?? 'unknown',
        email: user.email,
        name: user.externalName,
        projectClientName: activeProject?.projectClientName ?? 'unknown',
        projectDisplayName: activeProject?.projectDisplayName ?? 'unknown',
        userClientId: 'unknown', // Followup ticket to expose this in user data
        userClientName: user.companyName,
        intercom_user_jwt: token,
      };
      Intercom(config);
    }
  }, [user, isMobile, activeProject]);

  return { initiateIntercom };
};
